export interface InvoiceStateConfig {
  id: string;
  shortName: string;
  isPayAllowed: boolean;
}
// @TODO remove this mapper when possible. It leads to weird invoices sorting
export const states: { [key: string]: InvoiceStateConfig } = {
  1: {
    id: '1',
    shortName: 'В обробці',
    isPayAllowed: true,
  },
  2: {
    id: '6',
    shortName: 'Видалено',
    isPayAllowed: false,
  },
  3: {
    id: '6',
    shortName: 'Номер не знайдено',
    isPayAllowed: false,
  },
  30: {
    id: '3',
    shortName: 'Митне оформлення',
    isPayAllowed: true,
  },
  31: {
    id: '3',
    shortName: 'Митне оформлення',
    isPayAllowed: true,
  },
  4: {
    id: '2',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  41: {
    id: '2',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  5: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  6: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  7: {
    id: '4',
    shortName: 'Прибув у відділення',
    isPayAllowed: true,
  },
  8: {
    id: '4',
    shortName: 'Прибув у відділення',
    isPayAllowed: true,
  },
  101: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  9: {
    id: '5',
    shortName: 'Отримано',
    isPayAllowed: false,
  },
  10: {
    id: '5',
    shortName: 'Отримано',
    isPayAllowed: false,
  },
  11: {
    id: '5',
    shortName: 'Отримано',
    isPayAllowed: false,
  },
  13: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  16: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  14: {
    id: '4',
    shortName: 'Отримано',
    isPayAllowed: false,
  },
  99: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  104: {
    id: '5',
    shortName: 'Змінено адресу',
    isPayAllowed: false,
  },
  106: {
    id: '5',
    shortName: 'Отримано',
    isPayAllowed: false,
  },
  102: {
    id: '6',
    shortName: 'Відмова одержувача',
    isPayAllowed: true,
  },
  103: {
    id: '6',
    shortName: 'Відмова одержувача',
    isPayAllowed: true,
  },
  108: {
    id: '6',
    shortName: 'Відмова одержувача',
    isPayAllowed: true,
  },
  105: {
    id: '6',
    shortName: 'Припинено зберігання',
    isPayAllowed: false,
  },
  107: {
    id: '6',
    shortName: 'Нараховується плата за зберігання',
    isPayAllowed: true,
  },
  12: {
    id: '1',
    shortName: 'В обробці',
    isPayAllowed: true,
  },
  111: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  112: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  113: {
    id: '6',
    shortName: 'Припинено зберігання',
    isPayAllowed: true,
  },
  115: {
    id: '3',
    shortName: 'Митне оформлення',
    isPayAllowed: true,
  },
  116: {
    id: '3',
    shortName: 'Митне оформлення',
    isPayAllowed: true,
  },
  117: {
    id: '6',
    shortName: 'Вантаж не знайдено',
    isPayAllowed: true,
  },
  118: {
    id: '6',
    shortName: 'Заборонений вміст',
    isPayAllowed: true,
  },
  119: {
    id: '3',
    shortName: 'Митне оформлення',
    isPayAllowed: true,
  },
  120: {
    id: '3',
    shortName: 'Митне оформлення',
    isPayAllowed: true,
  },
  121: {
    id: '3',
    shortName: 'У дорозі',
    isPayAllowed: true,
  },
  999: {
    id: '',
    shortName: 'В обробці',
    isPayAllowed: true,
  },
};
